/** Rendered height of the app NavBar; every "below the bar" calc derives from this. */
export const NAVBAR_HEIGHT_PX = 56;

/** Extra breathing room some pages reserve below the bar. */
export const NAVBAR_GUTTER_PX = 15;

export const NAVBAR_HEIGHT = `${NAVBAR_HEIGHT_PX}px`;

export const NAVBAR_HEIGHT_PLUS15 = `${NAVBAR_HEIGHT_PX + NAVBAR_GUTTER_PX}px`;
